import { useGetDialogsQuery } from "../../dialogs/dialogsSlice";

const useHistoryWidget = () => {
  const dialogs = useGetDialogsQuery();
  const originalArray = dialogs?.data || [];
  const reversedArray = [...originalArray]
    ?.filter((item) => item?.status.toLowerCase() !== "wait_for_system")
    ?.reverse()
    ?.slice(0, 5);
  return { isLoading: dialogs?.isLoading, historyItems: reversedArray || [] };
};

export default useHistoryWidget;
